import { SEOHead } from '../components/SEOHead';
import { Footer } from '../components/Footer';
import { CallbackForm } from '../components/CallbackForm';
import { translations } from '../translations';

const contactTexts = {
  en: {
    heroTitle: 'Contact Viaturkey',
    heroSub: 'We are here to help you plan your Istanbul experience.',
    infoTitle: 'Get in Touch',
    email: 'Email',
    whatsapp: 'WhatsApp',
    phone: 'Phone',
    address: 'Address',
    addressText: 'Yedi Emirler Sk. No:18/9, Fatih/Istanbul/Turkey',
    hoursTitle: 'Business Hours',
    hoursWeekday: 'Monday - Friday: 9:00 AM - 7:00 PM (Istanbul)',
    hoursSaturday: 'Saturday: 10:00 AM - 4:00 PM (Istanbul)',
    hoursSunday: 'Sunday: Closed (WhatsApp available)',
    mapTitle: 'Our Location',
    followTitle: 'Follow Us',
  },
  ar: {
    heroTitle: 'تواصل مع Viaturkey',
    heroSub: 'نحن هنا لمساعدتك في التخطيط لتجربتك في إسطنبول.',
    infoTitle: 'تواصل معنا',
    email: 'البريد الإلكتروني',
    whatsapp: 'واتساب',
    phone: 'هاتف',
    address: 'العنوان',
    addressText: 'يدي أميرلر سك. رقم:18/9، الفاتح/إسطنبول/تركيا',
    hoursTitle: 'ساعات العمل',
    hoursWeekday: 'الاثنين - الجمعة: 9:00 ص - 7:00 م (بتوقيت إسطنبول)',
    hoursSaturday: 'السبت: 10:00 ص - 4:00 م (بتوقيت إسطنبول)',
    hoursSunday: 'الأحد: مغلق (واتساب متاح)',
    mapTitle: 'موقعنا',
    followTitle: 'تابعونا',
  },
  ru: {
    heroTitle: 'Связаться с Viaturkey',
    heroSub: 'Мы здесь, чтобы помочь вам спланировать ваш опыт в Стамбуле.',
    infoTitle: 'Свяжитесь с нами',
    email: 'Эл. почта',
    whatsapp: 'WhatsApp',
    phone: 'Телефон',
    address: 'Адрес',
    addressText: 'Еди Эмирлер Ск. No:18/9, Фатих/Стамбул/Турция',
    hoursTitle: 'Часы работы',
    hoursWeekday: 'Понедельник - Пятница: 9:00 - 19:00 (Стамбул)',
    hoursSaturday: 'Суббота: 10:00 - 16:00 (Стамбул)',
    hoursSunday: 'Воскресенье: Закрыто (WhatsApp доступен)',
    mapTitle: 'Наш адрес',
    followTitle: 'Подписывайтесь',
  },
  tr: {
    heroTitle: 'Viaturkey ile Iletisim',
    heroSub: 'Istanbul deneyiminizi planlamaniz icin buradayiz.',
    infoTitle: 'Bize Ulasin',
    email: 'E-posta',
    whatsapp: 'WhatsApp',
    phone: 'Telefon',
    address: 'Adres',
    addressText: 'Yedi Emirler Sk. No:18/9, Fatih/Istanbul/Turkiye',
    hoursTitle: 'Calisma Saatleri',
    hoursWeekday: 'Pazartesi - Cuma: 09:00 - 19:00 (Istanbul)',
    hoursSaturday: 'Cumartesi: 10:00 - 16:00 (Istanbul)',
    hoursSunday: 'Pazar: Kapali (WhatsApp acik)',
    mapTitle: 'Konumumuz',
    followTitle: 'Bizi Takip Edin',
  },
};

export default function ContactPage({ language, setLanguage }) {
  const t = translations[language];
  const ct = contactTexts[language] || contactTexts.en;
  const isAr = language === 'ar';

  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Viaturkey Investments & Tourism Co.",
    "url": "https://viaturkey.net",
    "telephone": "+905075337545",
    "email": "akin@viaturkey.net",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Yedi Emirler Sk. No:18/9",
      "addressLocality": "Fatih",
      "addressRegion": "Istanbul",
      "postalCode": "34080",
      "addressCountry": "TR"
    },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "09:00", "closes": "19:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "10:00", "closes": "16:00" }
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+905075337545",
      "contactType": "customer service",
      "availableLanguage": ["English","Arabic","Russian","Turkish"]
    }
  };

  return (
    <div className="contact-page" dir={isAr ? 'rtl' : 'ltr'} data-testid="contact-page">
      <SEOHead
        title={isAr ? 'تواصل معنا | Viaturkey' : 'Contact Us Istanbul | Viaturkey'}
        description={isAr ? 'تواصل مع Viaturkey للاستفسار عن جولات إسطنبول والعقارات والجنسية التركية. واتساب، بريد إلكتروني، أو اطلب معاودة اتصال.' : 'Contact Viaturkey for Istanbul tours, real estate, and Turkish citizenship inquiries. WhatsApp, email, or request a callback.'}
        canonical="https://viaturkey.net/contact"
        schema={schema}
      />

      <section className="cp-hero" data-testid="cp-hero">
        <div className="cp-hero-overlay"></div>
        <div className="cp-hero-content">
          <h1>{ct.heroTitle}</h1>
          <p>{ct.heroSub}</p>
        </div>
      </section>

      <div className="cp-container">
        <div className="cp-grid">
          <div className="cp-info" data-testid="cp-info">
            <h2>{ct.infoTitle}</h2>

            <div className="cp-info-card">
              <i className="fas fa-envelope"></i>
              <div>
                <strong>{ct.email}</strong>
                <a href="mailto:akin@viaturkey.net">akin@viaturkey.net</a>
              </div>
            </div>

            <div className="cp-info-card">
              <i className="fab fa-whatsapp"></i>
              <div>
                <strong>{ct.whatsapp}</strong>
                <a href="https://wa.me/905075337545" target="_blank" rel="noopener noreferrer">+90 507 533 75 45</a>
              </div>
            </div>

            <div className="cp-info-card">
              <i className="fas fa-phone-alt"></i>
              <div>
                <strong>{ct.phone}</strong>
                <a href="tel:+905075337545">+90 507 533 75 45</a>
              </div>
            </div>

            <div className="cp-info-card">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <strong>{ct.address}</strong>
                <span style={{whiteSpace: 'pre-line'}}>{ct.addressText}</span>
              </div>
            </div>

            <div className="cp-hours" data-testid="cp-hours">
              <h3>{ct.hoursTitle}</h3>
              <p>{ct.hoursWeekday}</p>
              <p>{ct.hoursSaturday}</p>
              <p>{ct.hoursSunday}</p>
            </div>

            <div className="cp-social">
              <h3>{ct.followTitle}</h3>
              <div className="cp-social-links">
                <a href="https://www.youtube.com/@akinguzel1490" target="_blank" rel="noopener noreferrer" data-testid="cp-youtube"><i className="fab fa-youtube"></i></a>
                <a href="https://www.instagram.com/via_turkey" target="_blank" rel="noopener noreferrer" data-testid="cp-instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://www.tiktok.com/@akingzel" target="_blank" rel="noopener noreferrer" data-testid="cp-tiktok"><i className="fab fa-tiktok"></i></a>
                <a href="https://x.com/akngzl3" target="_blank" rel="noopener noreferrer" data-testid="cp-twitter"><i className="fab fa-x-twitter"></i></a>
              </div>
            </div>
          </div>

          <div className="cp-form-side">
            <CallbackForm language={language} />
          </div>
        </div>

        <section className="cp-map" data-testid="cp-map">
          <h2>{ct.mapTitle}</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.2!2d28.925447!3d41.006880!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9be8e4b8f07%3A0x1b1b1b1b1b1b1b1b!2sFatih%2C%20Istanbul!5e0!3m2!1sen!2str!4v1716940800000!5m2!1sen!2str"
            width="100%" height="400" style={{ border: 0, borderRadius: '12px' }} allowFullScreen="" loading="lazy"
            referrerPolicy="no-referrer-when-downgrade" title="Viaturkey Office"
          ></iframe>
        </section>
      </div>

      <Footer t={t} />
    </div>
  );
}
